import { Loader } from '@googlemaps/js-api-loader'

export async function fetchAddressGeom(
  apiKey: string,
  address: string
): Promise<{ lat: number; lon: number } | null> {
  // Format Address
  try {
    const loader = new Loader({
      apiKey: apiKey || '',
      version: 'weekly',
      libraries: ['places']
    })

    const google = await loader.load()
    const geocoder = new google.maps.Geocoder()

    return new Promise((resolve) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      geocoder.geocode({ address }, (result: any, status: string) => {
        if (status === 'OK') {
          if (
            result &&
            result[0] &&
            result[0].geometry &&
            result[0].geometry.location &&
            typeof result[0].geometry.location.lat === 'function' &&
            typeof result[0].geometry.location.lng === 'function'
          ) {
            const loc = result[0].geometry.location
            const lat = loc.lat()
            const lon = loc.lng()
            if (typeof lat === 'number' && typeof lon === 'number') {
              return resolve({ lat, lon })
            }
          } else {
            return resolve(null)
          }
        } else {
          return resolve(null)
        }
      })
    })
  } catch (e) {
    return null
  }
}
